// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";
import * as ActiveStorage from "@rails/activestorage";
require.context("images/", true, /\.(gif|jpg|png|svg|eot|ttf|woff|woff2)$/i);
require.context("fonts/", true, /\.(gif|jpg|png|svg|eot|ttf|woff|woff2)$/i);
import "@fortawesome/fontawesome-free/js/all";
import "./thanks";
import "./user_trials/_form";
import "./entries/_form";
import "./entries/create";
import "./landing/landing";
import "./landing/youtube";
import "./opinions/index";
import "stylesheets/landing_page/application";

Rails.start();
ActiveStorage.start();

$(function () {
  $("a[href^='#']:not(a[href^='#tab'])").on("click", function () {
    var time = 500;
    var scrollTarget = $(this.hash);
    if (!scrollTarget.length) return;
    // 移動先となる値fs

    var targetY = scrollTarget.offset().top;
    // スクロールアニメーション
    $("html,body").animate({ scrollTop: targetY }, time, "swing");
    // ハッシュ書き換えとく
    window.history.pushState(null, null, this.hash);

    if ($(this).hasClass("menuLink")) {
      $(".menu").slideToggle();
      $(".button-toggle").toggleClass("active");
      $(".button-toggle").html("≡");
    } // デフォルトの処理はキャンセル
  });

  $(".button-toggle").on("click", function () {
    $(".menu").slideToggle();
    $(this).toggleClass("active");
    $(".action").toggleClass("hide");
    if ($(this).hasClass("active")) {
      $(".button-toggle").html("<span>×</span>");
    } else {
      $(".button-toggle").html("<span>≡</span>");
    }
  });
  $(".menuLink").on("click", function () {
    $(".menu").slideToggle();
    $(".button-toggle").toggleClass("active");
    $(".action").toggleClass("hide");
    if ($("button-toggle").hasClass("active")) {
      $(".button-toggle").html("<span>×</span>");
    } else {
      $(".button-toggle").html("<span>≡</span>");
    }
  });
  let error_block = $(".agreement .help-inline");
  if (error_block) {
    $(".agreement").prepend(error_block);
    error_block.css({ color: "#CD5C5C", "font-size": "small" });
  }
});
